import useTranslation from 'next-translate/useTranslation'

export const Processing: React.FC = () => {
  const { t } = useTranslation('settings')
  return (
    <div className="ml-auto w-3/5 text-right">
      <span
        className="text-xl leading-7 text-blue-500 font-circular-bold"
        data-testid="invoice-processing-title"
      >
        {t('billing.invoices.details.summary.processing')}
      </span>
      <div
        className="mt-2 py-2 text-xs leading-4 text-black-200 font-circular-regular"
        data-testid="invoice-processing-sub-text"
      >
        {t('billing.invoices.details.summary.processingInfo')}
      </div>
    </div>
  )
}
